// URL obfuscation helpers for route IDs.
// Note: This is obfuscation, not security. Backend must still enforce authz.

const base64UrlEncode = (input) => {
  try {
    const utf8 = encodeURIComponent(String(input)).replace(/%([0-9A-F]{2})/g, (_, p1) =>
      String.fromCharCode(parseInt(p1, 16))
    );
    return btoa(utf8).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/g, "");
  } catch (_) {
    return "";
  }
};

const base64UrlDecode = (input) => {
  try {
    const b64 = String(input).replace(/-/g, "+").replace(/_/g, "/");
    const pad = b64.length % 4 === 0 ? "" : "=".repeat(4 - (b64.length % 4));
    const str = atob(b64 + pad);
    const percentEncoded = str
      .split("")
      .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
      .join("");
    return decodeURIComponent(percentEncoded);
  } catch (_) {
    return "";
  }
};

export const encodeId = (id) => base64UrlEncode(String(id));

export const decodeId = (token) => {
  const decoded = base64UrlDecode(token);
  if (!decoded) return null;
  return decoded;
};

// v2: longer opaque token similar to a UUID-length using a salted digest.
// We keep decode compatibility by embedding the raw id before base64.
const SALT = "ppc_v1";

const deriveDigest = (input) => {
  // Lightweight deterministic hash (FNV-1a inspired, non-cryptographic)
  let h1 = 0x811c9dc5 >>> 0;
  let h2 = (0x811c9dc5 ^ 0xffffffff) >>> 0;
  const data = SALT + "|" + input;
  for (let i = 0; i < data.length; i++) {
    const c = data.charCodeAt(i);
    h1 ^= c;
    h1 = Math.imul(h1, 0x01000193) >>> 0;
    h2 ^= (c << (i % 24)) >>> 0;
    h2 = Math.imul(h2, 0x01000193) >>> 0;
  }
  const hex = (n) => ("00000000" + (n >>> 0).toString(16)).slice(-8);
  return (hex(h1) + hex(h2) + hex(h1 ^ h2) + hex((h1 + h2) >>> 0)).slice(0, 32);
};

export const encodeIdLong = (id) => {
  const raw = String(id);
  const digest = deriveDigest(raw);
  return base64UrlEncode(`${raw}:${digest}`);
};

export const decodeIdLong = (token) => {
  const decoded = base64UrlDecode(token);
  if (!decoded) return null;
  const idx = decoded.indexOf(":");
  if (idx === -1) return decoded; // fallback to v1 simple encoding
  return decoded.slice(0, idx);
};


